export default __webpack_public_path__ + "static/media/image-47.8c8853d5.png";